import PropTypes from 'prop-types';
import {Translate} from 'react-redux-i18n';
import {DialogModal} from 'front-onceforall-core';
import SuggestedOrganisationItem from '../SuggestedOrganisationItem';

function AcceptSuggestionModal({
  isOpen, onClose, suggestion, submitting, onSubmit
}) {
  if (!suggestion) { return null; }
  return (
    <DialogModal
      isOpen={isOpen}
      onClose={onClose}
      title={<Translate value="invitation.suggestion.accept"/>}
    >
      <SuggestedOrganisationItem suggestion={suggestion}/>
      <div className="flex-container row space-between mt-5">
        <button
          type="button"
          className="large secondary inline-container"
          data-id="cancel"
          onClick={onClose}
        >
          <Translate value="action.cancel"/>
        </button>
        <button
          disabled={submitting}
          type="submit"
          data-id="submit"
          className="large primary inline-container"
          onClick={onSubmit}
        >
          <Translate value="action.confirm"/>
        </button>
      </div>
    </DialogModal>
  );
}

AcceptSuggestionModal.propTypes = {
  suggestion: PropTypes.object,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  submitting: PropTypes.bool
};

export default AcceptSuggestionModal;
